import React, { useState, useRef, useEffect } from "react";
import FiltersSearch from "./Filters-search";
import MobileAdvance from "./Mobile-advance";
import SearchMap from "./Search-map";
import SubscriptionPausedBanner from "../../common/SubscriptionPausedBanner";
import PaymentFailedBanner from "../../common/PaymentFailedBanner";
import ReferralSidebar from "../../common/ReferralSidebar";
import { useNavigate, useSearchParams, useLocation } from "react-router-dom";
import useDocumentTitle from "../../../hooks/useDocumentTitle";
import NewFiltersForm from "./new-filters-form";
import FiltersSearchNew from "./Filters-search-new";
import { toast } from "react-toastify";
import { TOAST_SETTINGS } from "../../../utils/siteSettings";
import { REMOVED_COMMERCIAL_FILTERS_KEY } from "../../../helpers/commercialFilterUtils";
const SearchNewProperty = () => {
  // Opening a saved search that had commercial categories stripped lands here
  // via a full document load, which destroys any toast the saved-searches page
  // raised. It leaves the notice in sessionStorage instead; show it once here.
  useEffect(() => {
    let notice = null;
    try {
      notice = sessionStorage.getItem(REMOVED_COMMERCIAL_FILTERS_KEY);
      if (notice) {
        sessionStorage.removeItem(REMOVED_COMMERCIAL_FILTERS_KEY);
      }
    } catch (e) {
      // Private mode or blocked storage — nothing to show.
    }

    if (notice) {
      toast.info(notice, { ...TOAST_SETTINGS, autoClose: 6000 });
    }
  }, []);

  const [showowners, setShowowners] = useState(true);
  const ownertoggle = () => {
    setShowowners(!showowners);
  };
  const [canSaveScroll, setCanSaveScroll] = useState(false);
  useEffect(() => {
    const onPageLoad = () => {
      const savedScrollPosition = localStorage.getItem("scrollPosition");

      if (savedScrollPosition) {
        // Add a delay to ensure content is fully loaded
        setTimeout(() => {
          window.scrollTo(0, parseInt(savedScrollPosition, 10));
          // alert("triggered")
        }, 4000);

        // Start tracking new scroll only after reaching stored position
        const checkScroll = () => {
          if (window.scrollY >= parseInt(savedScrollPosition, 10)) {
            setCanSaveScroll(true);
            window.removeEventListener("scroll", checkScroll);
          }
        };

        window.addEventListener("scroll", checkScroll);

        return () => {
          window.removeEventListener("scroll", checkScroll);
        };
      } else {
        setCanSaveScroll(true);
      }
    };

    if (document.readyState === "complete") {
      onPageLoad();
    } else {
      window.addEventListener("load", onPageLoad);
    }

    return () => {
      window.removeEventListener("load", onPageLoad);
    };
  }, []);

  useEffect(() => {
    if (!canSaveScroll) return;

    const handleScroll = () => {
      localStorage.setItem("scrollPosition", window.scrollY);
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [canSaveScroll]);
  const [searchParams] = useSearchParams();
  const search_keyword = searchParams.get("search_p");
  // console.log("search_keyword",search_keyword)
  const [hideSearch, setHideSearch] = useState(false);
  const [showMap, setShowMap] = useState(true);
  const [resultView, setResultView] = useState(true);
  const [drawnFeatures, setDrawnFeatures] = useState(null);
  

  const searchRef = useRef(null);
  const handleSearchClick = () => {
    if (searchRef.current) {
      searchRef.current.click();
    }
  };
  const ToggleHideSearch = () => {
    setHideSearch(!hideSearch);
  };

  const Maptoggle = () => {
    setShowMap(!showMap);
  };
  useDocumentTitle("Search Properties -  Rhino Recon");
  return (
    <>
      <div className="contain-fluid">
        <SubscriptionPausedBanner />
        <PaymentFailedBanner />
      </div>

      {/* <NewFiltersForm /> */}
      <FiltersSearchNew
        ToggleHideSearch={ToggleHideSearch}
        Maptoggle={Maptoggle}
        hideSearch={hideSearch}
        showMap={showMap}
        setShowMap={setShowMap}
        drawnFeatures={drawnFeatures}
        setDrawnFeatures={setDrawnFeatures}
        searchRef={searchRef}
        search_keyword={search_keyword}
        ownertoggle={ownertoggle}
      />
      {/*
        Side-by-side layout: the map takes the remaining width (flex: 1),
        the referral sidebar takes a fixed column on the right. When the
        sidebar returns null (dismissed, ineligible, or before
        site-settings resolves), the flex collapses to map-only and the
        Mapbox canvas re-fits via its ResizeObserver — no map.resize()
        needed. `minWidth: 0` on the map flex child lets it actually
        shrink below the map's intrinsic width.
      */}
      <div
        className="search_map_with_sidebar"
        style={{ display: "flex", alignItems: "flex-start" }}
      >
        <div style={{ flex: 1, minWidth: 0 }}>
          <SearchMap
            hideSearch={hideSearch}
            showMap={showMap}
            setDrawnFeatures={setDrawnFeatures}
            drawnFeatures={drawnFeatures}
            handleSearchClick={handleSearchClick}
            setshowMap={setShowMap}
            Maptoggle={Maptoggle}
          />
        </div>
        <ReferralSidebar />
      </div>
    </>
  );
};

export default SearchNewProperty;
